/**
 * isiXhosa: AI tools
 *
 * What this file covers: The AI tools page: writing with skills, answers from the business's documents, image to text, saved skills and the history of AI calls with what each cost.
 *
 * Tone: Friendly and plain, for business owners trying AI for the first time. Say what each tool does and what it costs in a few words; never promise more than the AI can do.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const ai: Catalog = {
};

export default ai;
